import { render, staticRenderFns } from "./VLegend.vue?vue&type=template&id=b117db68&"
import script from "./VLegend.vue?vue&type=script&lang=js&"
export * from "./VLegend.vue?vue&type=script&lang=js&"
import style0 from "./VLegend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports